import React from 'react';

const Fragments = ({ component, children, ...rest }) =>
  React.createElement(
    component,
    rest,
    ...React.Children.map(children, child => React.Children.toArray(child.props.children))
  );

const Fragment = () => null;

export { Fragments, Fragment };
